import {rotaBusca} from './rotas';
export function abrirAnalyser(location, navigate) {
  // A tela atual confirma o evento para conservar seus filtros e sua seleção.
  if (!window.dispatchEvent(new Event('leila:investigar-riscos', {cancelable:true}))) return;
  const busca = rotaBusca(location.pathname);
  let destino = busca;
  try {
    const anterior = new URL(sessionStorage.getItem('lastLeiloesURL') || '', window.location.origin);
    if (anterior.origin === window.location.origin && anterior.pathname === busca) destino = anterior.pathname + anterior.search;
  } catch {}
  navigate(destino, {state:{investigarRiscos:true}});
}
